import { render, staticRenderFns } from "./InformationWrapperNew.vue?vue&type=template&id=42257808&scoped=true"
var script = {}
import style0 from "./InformationWrapperNew.vue?vue&type=style&index=0&id=42257808&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42257808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42257808')) {
      api.createRecord('42257808', component.options)
    } else {
      api.reload('42257808', component.options)
    }
    module.hot.accept("./InformationWrapperNew.vue?vue&type=template&id=42257808&scoped=true", function () {
      api.rerender('42257808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inforationCards/InformationWrapperNew.vue"
export default component.exports